document.addEventListener('DOMContentLoaded', function () {
  var overlay  = document.querySelector('.js-mini-cart-overlay');
  var cartRoot = overlay && overlay.querySelector('.js-mini-cart');
  if (!overlay || !cartRoot) return;

  var isBusy = false;

  // ---------------- open / close ----------------

  var html        = document.documentElement;
  var openButtons = document.querySelectorAll('.cart-button');
  var closeBtn    = cartRoot.querySelector('.mini-cart-close');

  function openMiniCart() {
    overlay.classList.add('is-open');
    html.classList.add('mini-cart-open');
  }

  function closeMiniCart() {
    overlay.classList.remove('is-open');
    html.classList.remove('mini-cart-open');
  }

  openButtons.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      openMiniCart();
    });
  });

  if (closeBtn) {
    closeBtn.addEventListener('click', function (e) {
      e.preventDefault();
      closeMiniCart();
    });
  }

  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) {
      closeMiniCart();
    }
  });

  document.addEventListener('keyup', function (e) {
    if (e.key === 'Escape') {
      closeMiniCart();
    }
  });

  // ---------- helpers ----------

  function toInt(v) {
    return parseInt(v, 10) || 0;
  }

  function ensureDollar(formatted) {
    var text = String(formatted == null ? '' : formatted).trim();
    if (!text) return '$0';
    text = text.replace(/([.,]00)(?=\s*(?:[A-Za-z]{3})?$)/, '');
    return text.indexOf('$') === -1 ? ('$' + text) : text;
  }

  function formatMoney(cents) {
    var formatted = '';
    try {
      if (typeof Shopify !== 'undefined' &&
          typeof Shopify.formatMoney === 'function' &&
          typeof Shopify.money_format !== 'undefined') {
        formatted = Shopify.formatMoney(cents, Shopify.money_format);
      }
    } catch (e) {}

    if (!formatted) {
      var value = (cents || 0) / 100;
      formatted = value.toFixed(2);
    }

    return ensureDollar(formatted);
  }

  // ---------- totals by variant ----------

  function getVariantTotals() {
    var rows   = cartRoot.querySelectorAll('.cart-row[data-variant-id]');
    var totals = {};

    rows.forEach(function (row) {
      var vid = row.getAttribute('data-variant-id');
      if (!vid) return;

      var qtyEl = row.querySelector('.cart-page-qty-value');
      var qty   = qtyEl ? toInt(qtyEl.textContent) : 0;

      var qtyWrap = row.querySelector('.cart-row-qty');
      var maxAttr = qtyWrap && qtyWrap.dataset.maxQty ? qtyWrap.dataset.maxQty : null;
      var maxNum  = maxAttr ? toInt(maxAttr) : null;

      if (!totals[vid]) {
        totals[vid] = {
          total: 0,
          max: maxNum
        };
      }

      totals[vid].total += qty;

      if (maxNum !== null) {
        if (totals[vid].max === null || maxNum < totals[vid].max) {
          totals[vid].max = maxNum;
        }
      }
    });

    return totals;
  }

  function canIncreasePack(row, totals) {
    if (row.dataset.isPackBox !== '1') return true;

    totals = totals || getVariantTotals();

    var qtyEl   = row.querySelector('.cart-page-qty-value');
    var packQty = qtyEl ? toInt(qtyEl.textContent) : 0;

    var qtyWrap = row.querySelector('.cart-row-qty');
    var maxPack = qtyWrap && qtyWrap.dataset.maxQty ? toInt(qtyWrap.dataset.maxQty) : null;
    if (maxPack !== null && packQty >= maxPack) {
      return false;
    }

    var boxId = row.dataset.boxId || '';
    if (!boxId) return true;

    var truffleRows = Array.prototype.slice.call(
      cartRoot.querySelectorAll(
        '.cart-row.cart-row--hidden-truffle[data-box-id="' + boxId + '"]'
      )
    );

    for (var i = 0; i < truffleRows.length; i++) {
      var tRow   = truffleRows[i];
      var tQtyEl = tRow.querySelector('.cart-page-qty-value');
      var tQty   = tQtyEl ? toInt(tQtyEl.textContent) : 0;
      if (packQty <= 0) continue;

      var perBox = Math.round(tQty / packQty) || 0;
      if (perBox <= 0) continue;

      var vid  = tRow.getAttribute('data-variant-id');
      var info = totals[vid];
      if (!info || info.max === null || !isFinite(info.max)) continue;

      var used = info.total;
      var max  = info.max;

      if (used + perBox > max) {
        return false;
      }
    }

    return true;
  }

  // ---------- UI qty + buttons ----------

  function updateQtyDom(row, qty, totals) {
    var valueEl  = row.querySelector('.cart-page-qty-value');
    var minusBtn = row.querySelector('.cart-page-qty-minus');
    var plusBtn  = row.querySelector('.cart-page-qty-plus');
    var qtyWrap  = row.querySelector('.cart-row-qty');

    if (valueEl) valueEl.textContent = qty;

    if (minusBtn) {
      minusBtn.disabled = qty <= 1;
    }

    if (!plusBtn) return;

    plusBtn.disabled = false;

    var vid   = row.getAttribute('data-variant-id');
    var info  = totals && vid ? totals[vid] : null;
    var maxGl = info && info.max !== null ? info.max : null;
    var used  = info ? info.total : null;

    if (row.dataset.isPackBox !== '1') {
      if (maxGl !== null && used !== null && used >= maxGl) {
        plusBtn.disabled = true;
      } else if (qtyWrap && qtyWrap.dataset.maxQty) {
        var maxRow = toInt(qtyWrap.dataset.maxQty);
        if (qty >= maxRow) {
          plusBtn.disabled = true;
        }
      }
      return;
    }

    if (!canIncreasePack(row, totals)) {
      plusBtn.disabled = true;
    }
  }

  function refreshInventoryLimits() {
    var totals = getVariantTotals();
    var rows   = cartRoot.querySelectorAll('.cart-row');

    rows.forEach(function (row) {
      var qtyEl = row.querySelector('.cart-page-qty-value');
      var qty   = qtyEl ? toInt(qtyEl.textContent) : 0;
      updateQtyDom(row, qty, totals);
    });
  }

  // Пересчёт сумм трюфелей внутри PACK TRUFFLES
  function recalcPackSubitems() {
    var packRows = cartRoot.querySelectorAll('.cart-row[data-is-pack-box="1"]');
    packRows.forEach(function (row) {
      var qtyEl = row.querySelector('.cart-page-qty-value');
      var packQty = toInt(qtyEl && qtyEl.textContent);
      if (!packQty || packQty < 1) packQty = 1;
      var baseLineCents = toInt(row.getAttribute('data-line-price-cents'));
      var extraLineCents = 0;

      var subitems = row.querySelectorAll('.cart-row-subitem');
      subitems.forEach(function (sub) {
        var perBox = toInt(sub.getAttribute('data-per-box-qty'));
        var unitPrice = toInt(sub.getAttribute('data-unit-price'));

        if (!perBox || !unitPrice) return;

        var qtySpan = sub.querySelector('.cart-row-subitem-qty');
        if (qtySpan) {
          qtySpan.textContent = perBox;
        }

        var lineTotalCents = unitPrice * perBox * packQty;
        extraLineCents += lineTotalCents;

        var totalSpan = sub.querySelector('.cart-row-subitem-total');
        if (totalSpan) {
          totalSpan.textContent = formatMoney(lineTotalCents);
        }
      });

      var priceEl = row.querySelector('.cart-row-price');
      if (priceEl) {
        priceEl.textContent = formatMoney(baseLineCents + extraLineCents);
      }
    });
  }

  // ---------- ajax helpers ----------

  function applyCartJsonToDom(cart) {
    if (!cart || !cart.items) return;

    var subtotalEl = cartRoot.querySelector('.mini-cart-summary-value');
    if (subtotalEl) {
      subtotalEl.textContent = formatMoney(cart.total_price);
    }

    cart.items.forEach(function (item, index) {
      var line = index + 1;
      var row  = cartRoot.querySelector('.cart-row[data-line="' + line + '"]');
      if (!row) return;
      row.setAttribute('data-line-price-cents', item.final_line_price);

      var priceEl = row.querySelector('.cart-row-price');
      if (priceEl) {
        priceEl.textContent = formatMoney(item.final_line_price);
      }

      updateQtyDom(row, item.quantity);
    });

    recalcPackSubitems();
    refreshInventoryLimits();
  }

  function ajaxChange(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        line: line,
        quantity: quantity
      })
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        if (!cart || !cart.items) {
          window.location.reload();
          throw new Error('Bad cart json');
        }
        applyCartJsonToDom(cart);
        return cart;
      });
  }

  // ---------- change simple line ----------

  function changeSimpleLine(row, delta) {
    if (isBusy) return;

    var line = toInt(row.dataset.line);
    if (!line) return;

    var qtyEl = row.querySelector('.cart-page-qty-value');
    var qty   = toInt(qtyEl.textContent);
    var next  = qty + delta;
    if (next < 1) return;

    if (delta > 0) {
      var totals = getVariantTotals();
      var vid    = row.getAttribute('data-variant-id');
      var info   = totals[vid];
      if (info && info.max !== null && info.total >= info.max) {
        return;
      }
    }

    isBusy = true;
    ajaxChange(line, next)
      .catch(function (err) {
        console.error('mini-cart change line error', err);
      })
      .finally(function () {
        isBusy = false;
      });
  }

  // ---------- change PACK TRUFFLES ----------

  function changePackLine(row, delta) {
    if (isBusy) return;

    if (delta > 0 && !canIncreasePack(row)) {
      return;
    }

    var line = toInt(row.dataset.line);
    if (!line) return;

    var qtyEl    = row.querySelector('.cart-page-qty-value');
    var packQty  = toInt(qtyEl.textContent);
    var nextPack = packQty + delta;
    if (nextPack < 1) return;

    var boxId = row.dataset.boxId || '';
    var truffleRows = [];
    if (boxId) {
      truffleRows = Array.prototype.slice.call(
        cartRoot.querySelectorAll(
          '.cart-row.cart-row--hidden-truffle[data-box-id="' + boxId + '"]'
        )
      );
    }

    var truffleUpdates = [];

    for (var i = 0; i < truffleRows.length; i++) {
      var tRow = truffleRows[i];
      var tLine = toInt(tRow.dataset.line);
      if (!tLine) continue;

      var tQtyEl = tRow.querySelector('.cart-page-qty-value');
      var tQty   = tQtyEl ? toInt(tQtyEl.textContent) : 0;
      if (packQty <= 0) continue;

      var perBox = Math.round(tQty / packQty) || 0;
      var tNext  = perBox * nextPack;

      var tWrap = tRow.querySelector('.cart-row-qty');
      var tMax  = tWrap && tWrap.dataset.maxQty ? toInt(tWrap.dataset.maxQty) : null;
      if (tMax && tNext > tMax) {
        return;
      }

      truffleUpdates.push({ line: tLine, qty: tNext });
    }

    isBusy = true;

    var chain = ajaxChange(line, nextPack);
    truffleUpdates.forEach(function (u) {
      chain = chain.then(function () {
        return ajaxChange(u.line, u.qty);
      });
    });

    chain
      .catch(function (err) {
        console.error('mini-cart change pack error', err);
      })
      .finally(function () {
        isBusy = false;
      });
  }

  // ---------- remove line (box + truffles) ----------

  function removeLine(row) {
    if (isBusy) return;

    var mainLine = toInt(row.dataset.line);
    if (!mainLine) return;

    var lines = [mainLine];

    var boxId = row.dataset.boxId || '';
    if (row.dataset.isPackBox === '1' && boxId) {
      var related = cartRoot.querySelectorAll(
        '.cart-row.cart-row--hidden-truffle[data-box-id="' + boxId + '"]'
      );
      related.forEach(function (tRow) {
        var tLine = toInt(tRow.dataset.line);
        if (tLine) lines.push(tLine);
      });
    }

    lines.sort(function (a, b) { return b - a; });

    isBusy = true;

    var chain = Promise.resolve();
    lines.forEach(function (ln) {
      chain = chain.then(function () {
        return ajaxChange(ln, 0);
      });
    });

    chain
      .then(function () {
        window.location.reload();
      })
      .catch(function (err) {
        console.error('mini-cart remove error', err);
        window.location.reload();
      })
      .finally(function () {
        isBusy = false;
      });
  }

  // ---------- EMPTY / CHECKOUT ----------

  var emptyBtn = cartRoot.querySelector('.js-mini-cart-empty');
  if (emptyBtn) {
    emptyBtn.addEventListener('click', function () {
      if (isBusy) return;
      isBusy = true;
      fetch('/cart/clear.js', { method: 'POST' })
        .then(function () {
          window.location.reload();
        })
        .catch(function (err) {
          console.error('mini-cart clear cart error', err);
        })
        .finally(function () {
          isBusy = false;
        });
    });
  }

  var checkoutBtn = cartRoot.querySelector('.mini-cart-checkout');
  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', function () {
      if (checkoutBtn.disabled) return;

      var url = checkoutBtn.getAttribute('data-checkout-url');
      if (!url) url = '/checkout';

      window.location.href = url;
    });
  }

  // ---------- click delegation for + / - / delete ----------

  cartRoot.addEventListener('click', function (e) {
    var plusBtn   = e.target.closest('.cart-page-qty-plus');
    var minusBtn  = e.target.closest('.cart-page-qty-minus');
    var removeBtn = e.target.closest('.cart-page-remove');

    if (!plusBtn && !minusBtn && !removeBtn) return;

    var row = e.target.closest('.cart-row');
    if (!row) return;

    if (plusBtn) {
      if (row.dataset.isPackBox === '1') {
        changePackLine(row, +1);
      } else {
        changeSimpleLine(row, +1);
      }
      return;
    }

    if (minusBtn) {
      if (row.dataset.isPackBox === '1') {
        changePackLine(row, -1);
      } else {
        changeSimpleLine(row, -1);
      }
      return;
    }

    if (removeBtn) {
      removeLine(row);
    }
  });

  // начальная инициализация
  refreshInventoryLimits();
  recalcPackSubitems();
});
